'use client';

import { c as _c } from "react/compiler-runtime";
import type { ToasterProps } from 'sonner';
import { CircleCheckIcon, InfoIcon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';
import { Spinner } from './spinner';
export function Toaster(props) {
  const $ = _c(6);
  const {
    theme: t0
  } = useTheme();
  const theme = t0 === undefined ? "system" : t0;
  const t1 = theme as ToasterProps['theme'];
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      success: <CircleCheckIcon className="size-4" />,
      info: <InfoIcon className="size-4" />,
      warning: <TriangleAlertIcon className="size-4" />,
      error: <OctagonXIcon className="size-4" />,
      loading: <Spinner />
    };
    t3 = {
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)",
      "--border-radius": "var(--radius)"
    };
    t4 = {
      classNames: {
        toast: "cn-toast"
      }
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== props || $[4] !== t1) {
    t5 = <Sonner theme={t1} className="toaster group" icons={t2} style={t3} toastOptions={t4} {...props} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}